import React from 'react';
// TODO: Import @material-ui from design-system folder
/* eslint-disable restrict-imports/restrict-imports */
import Tooltip from '@material-ui/core/Tooltip';
import Markdown from '@scale/frontend-lib/markdown';
import { makeStyles } from 'design-system/styles';
import classNames from 'classnames';

interface HintTooltipIconProps {
  hint: string;
  link?: boolean;
  classes?: Record<'button', string>;
}

const HintTooltipIcon: React.FC<HintTooltipIconProps> = props => {
  const classes = useHintTooltipIconStyles();
  const innerHTML = React.useMemo(() => {
    const html: string = Markdown.renderInline(props.hint);
    return { __html: html };
  }, [props.hint]);

  return (
    <Tooltip
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      leaveDelay={props.link ? 800 : 200}
      placement="top"
      title={
        props.link ? (
          <div className={classes.tooltip}>
            <a href={props.hint} target="_blank" rel="noopener noreferrer">
              {props.hint}
            </a>
          </div>
        ) : (
          <div className={classes.tooltip} dangerouslySetInnerHTML={innerHTML} />
        )
      }
    >
      <span className={classNames(classes.button, props.classes?.button)}>
        <InfoIcon className={classes.icon} width="16" height="16" />
      </span>
    </Tooltip>
  );
};

HintTooltipIcon.displayName = 'HintTooltipIcon';

const useHintTooltipIconStyles = makeStyles({
  tooltip: {
    padding: 2,
    maxWidth: 496,
    fontSize: 14,
    pointerEvents: 'auto',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    width: 32,
    height: 16,
    paddingLeft: 8,
    paddingRight: 8,
  },
  icon: {
    fill: '#000',
    opacity: 0.5,
  },
});

const InfoIcon: React.FC<React.SVGAttributes<SVGElement>> = props => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M12 2.70117C6.86409 2.70117 2.69998 6.86678 2.69998 12.0012C2.69998 17.1386 6.86409 21.3012 12 21.3012C17.1359 21.3012 21.3 17.1386 21.3 12.0012C21.3 6.86678 17.1359 2.70117 12 2.70117ZM12 6.82617C12.8698 6.82617 13.575 7.53132 13.575 8.40117C13.575 9.27102 12.8698 9.97617 12 9.97617C11.1301 9.97617 10.425 9.27102 10.425 8.40117C10.425 7.53132 11.1301 6.82617 12 6.82617ZM14.1 16.3512C14.1 16.5997 13.8985 16.8012 13.65 16.8012H10.35C10.1015 16.8012 9.89998 16.5997 9.89998 16.3512V15.4512C9.89998 15.2027 10.1015 15.0012 10.35 15.0012H10.8V12.6012H10.35C10.1015 12.6012 9.89998 12.3997 9.89998 12.1512V11.2512C9.89998 11.0027 10.1015 10.8012 10.35 10.8012H12.75C12.9985 10.8012 13.2 11.0027 13.2 11.2512V15.0012H13.65C13.8985 15.0012 14.1 15.2027 14.1 15.4512V16.3512Z" />
    </svg>
  );
};

export default HintTooltipIcon;
